import React, { FC, memo, useMemo } from 'react';
import { Space } from 'udesk-ui';
import LanguageSelect from 'Component/pages/components/LanguageSelect';
import { RuleConfig } from 'src/api/types';
import UdeskLocales from 'UdeskLocales';
import { SelectProps } from 'antd';

export interface TemplateProps {
    value?: RuleConfig;
    onChange?: (value: TemplateProps['value']) => void;
    sourceDisabledList?: number[];
    targetDisabledList?: number[];
    options?: SelectProps<number>['options'];
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange, sourceDisabledList = [], targetDisabledList = [], options } = props;

    const sourceOptions = useMemo(() => {
        return options?.map((o) => {
            return {
                ...o,
                disabled: sourceDisabledList.includes(o.value),
            };
        });
    }, [options, sourceDisabledList]);

    const targetOptions = useMemo(() => {
        return options?.map((o) => {
            return {
                ...o,
                disabled: [...(value?.sourceLang || []), ...targetDisabledList].includes(o.value),
            };
        });
    }, [options, targetDisabledList, value?.sourceLang]);

    return (
        <div>
            <Space>
                <Space size="small">
                    <div>
                        {/* 源语言 */}
                        {
                            UdeskLocales['current'].pages.qaLanguageSetting.translate.template
                                .components.rules.components.item.index.sourceLanguage
                        }
                    </div>
                    <LanguageSelect
                        value={value?.sourceLang}
                        onChange={(v) =>
                            onChange?.({
                                ...value,
                                sourceLang: v as number[],
                                targetLang: undefined,
                            })
                        }
                        mode="multiple"
                        maxTagCount={2}
                        style={{ width: 250 }}
                        options={sourceOptions}
                        disabledList={sourceDisabledList}
                    />
                </Space>

                <Space size="small">
                    <div>
                        {/* 目标语言 */}
                        {
                            UdeskLocales['current'].pages.qaLanguageSetting.translate.template
                                .components.rules.components.item.index.targetLanguage
                        }
                    </div>
                    <LanguageSelect
                        value={value?.targetLang}
                        onChange={(v) => onChange?.({ ...value, targetLang: v as number })}
                        style={{ width: 250 }}
                        options={targetOptions}
                        disabledList={[...(value?.sourceLang || []), ...targetDisabledList]}
                    />
                </Space>
            </Space>
        </div>
    );
});

export default Template;
